import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {HTHGameAssets} from "../HTHGameAssets";
import {HTH} from "../HTH";
import {HTHGameMode} from "../server/HTHGameMode";
import {gsap} from "gsap";
import {HTHHelper} from "../utils/HTHHelper";
import {HTHSound} from "../sound/HTHSound";

export class HTHBackgroundElements extends PIXI.Container implements StageLayer {

    private _backgroundContainer: PIXI.Container;
    private _backgroundMain: PIXI.spine.Spine;
    private _backgroundFS: PIXI.spine.Spine;
    private _reelBG: PIXI.Sprite;
    private currentState: string = "main";

    constructor() {
        super();
        this.name = "HTHBackgroundElements";
        this.init();
    }

    public onOrientationChanged() {

    }

    public onResize() {

    }

    public setMode(mode: string) {
        if (mode.includes("FREESPIN") || mode == HTHGameMode.EXTRA_SPIN) {
            if (this.currentState === "main") {
                this.swapBGToFS(false);
                this.currentState = "fs";
            }
        } else {
            if (this.currentState === "fs") {
                this.swapBGToMain(false);
                this.currentState = "main";
            }
        }
    }

    public startMode(mode: string): void {
        if (mode.includes("FREESPIN") || mode == HTHGameMode.EXTRA_SPIN) {
            this.swapBGToFS(true);
            this.currentState = "fs";
        } else {
            this.swapBGToMain(true);
            this.currentState = "main";
        }
    }

    private init() {
        this._backgroundContainer = new PIXI.Container();

        this._backgroundMain = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("mainBG"));
        this._backgroundMain.position.set(360, 360);
        // this._backgroundMain.alpha = 0.65;
        this._backgroundMain.name = "mainGameBG";

        this._backgroundFS = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("fsBG"));
        this._backgroundFS.position.set(360, 360);
        this._backgroundFS.name = "FSBG";

        this._backgroundContainer.addChild(this._backgroundMain, this._backgroundFS);
        this._backgroundContainer.position.set(0, 0);

        this.addChild(this._backgroundContainer);

        this._reelBG = new PIXI.Sprite(HTH.assetLoader.getTextures(HTHGameAssets.REEL_BG)[0]);
        this._reelBG.position.set(360, 384);
        this._reelBG.anchor.set(0.5, 0.5);
        this._reelBG.scale.set(1, 1);
        this._reelBG.name = "reelBG";

        this.addChild(this._reelBG);

        this.onOrientationChanged();
        this.onResize();
    }

    private swapBGToFS(isFirstLoaded: boolean): void {
        const swapTl: gsap.core.Timeline = gsap.timeline();
        this._backgroundFS.scale.set(0.85, 0.85);
        HTH.fsGainedView.transitionFire.scale.set(1, 1);
        if (!isFirstLoaded) {
            swapTl.add(() => {
                HTHSound.playTrack(HTHSound.BG_TRANSITION);
            }, 0);
        }
        swapTl.add(() => {
            this._backgroundFS.state.setAnimation(0, "fs_bg", true);
        }, 0);
        swapTl.add(HTHHelper.playSpineWithTimeline(HTH.fsGainedView.transitionFire, 0, "bw_transition"), 0);
        swapTl.to(this._backgroundMain, {alpha: 0, duration: 0.2}, 0.5);
        swapTl.to(this._backgroundFS, {alpha: 1, duration: 0.2}, "<");
        swapTl.to(this._backgroundFS.scale, {x: 1, y: 1, duration: 0.2}, "<");
        swapTl.add(() => {
            this.resetSpine(this._backgroundMain);
        }, ">");

    }

    private swapBGToMain(isFirstTimeLoaded: boolean): void {
        const swapbgTl: gsap.core.Timeline = gsap.timeline();
        this._backgroundMain.scale.set(0.85, 0.85);
        HTH.fsGainedView.transitionFire.scale.set(-1, 1);
        if (!isFirstTimeLoaded) {
            swapbgTl.add(() => {
                HTHSound.playTrack(HTHSound.BG_TRANSITION);
            }, 0);
        }
        swapbgTl.add(() => {
            HTHSound.soundSwitchedDuringFS = false;
            this._backgroundMain.state.setAnimation(0, "main_bg", true);
        }, 0);
        swapbgTl.add(HTHHelper.playSpineWithTimeline(HTH.fsGainedView.transitionFire, 0, "bw_transition"), "<");
        swapbgTl.to(this._backgroundFS, {alpha: 0, duration: 0.2}, 0.5);
        swapbgTl.to(this._backgroundMain, {alpha: 1, duration: 0.2}, "<");
        swapbgTl.to(this._backgroundMain.scale, {x: 1, y: 1, duration: 0.2}, "<");
        swapbgTl.add(() => {
            this.resetSpine(this._backgroundFS);
        }, ">");

    }

    private resetSpine(bgspine: PIXI.spine.Spine): void {
        bgspine.state.clearTracks();
        bgspine.skeleton.setToSetupPose();
        bgspine.skeleton.setSlotsToSetupPose();
        bgspine.state.setEmptyAnimation(0, 0);
    }
}